import { render, staticRenderFns } from "./CrewBehavior.vue?vue&type=template&id=e39a228e&scoped=true&"
import script from "./CrewBehavior.vue?vue&type=script&lang=js&"
export * from "./CrewBehavior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39a228e",
  null
  
)

export default component.exports